import styled from '@benzinga/themetron';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { ValueFormatterParams } from 'ag-grid-community';
import React from 'react';
import { NO_VALUE } from '../../Ticker';
import { CustomCellRendererProps } from 'ag-grid-react';
import { comparators, isNil, isNotNil } from '@benzinga/utils';
import { getCellValueOrDefault } from '../helpers';

const ChangePercentRenderer: React.FC<CustomCellRendererProps> = props => {
  const val = props.value;
  const valFormat = props.valueFormatted;
  if (isNil(val)) {
    return <Neutral>{NO_VALUE}</Neutral>;
  } else if (val === 0) {
    return <Neutral>{valFormat}</Neutral>;
  } else if (val > 0) {
    return <Positive>{valFormat}</Positive>;
  } else {
    return <Negative>{valFormat}</Negative>;
  }
};

const Neutral = styled.div`
  padding: 0 6px;
`;

const Positive = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.positive} !important;
  fill: ${({ theme }) => theme.colors.statistic.positive} !important;
`;

const Negative = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.negative} !important;
  fill: ${({ theme }) => theme.colors.statistic.negative} !important;
`;

export const ChangeDollarColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: ChangePercentRenderer,
  cellStyle: { textAlign: 'left' },

  // renderer handles
  comparator: (valueA: number, valueB: number) => valueA - valueB,

  filter: 'agNumberColumnFilter',
  valueFormatter: ({ value }: ValueFormatterParams) => (isNotNil(value) ? `$${value}` : NO_VALUE),
  valueGetter: colDef.valueGetter ?? getCellValueOrDefault,
  ...colDef,
  ...absColDef({
    ...colDef,
    comparator: colDef.comparator ?? comparators.numberComparator,
  }),
});
